<template>
    <div class="top center-box">
      <div class="top-box max-width-1920" :style="{backgroundImage: 'url('+ topBannerImg +')'}">
        <div class="content-positioning" data-aos="fade-up" :style="contentStype">
          <div class="title-2">{{ title2 }}</div>
          <slot></slot>
          <div class="title-1" :style="titleStyle">{{ titleRow1 }}</div>
          <div v-if="special" :style="titleStyle" class="title-1 mg-b-30">进行<span style="color: #016BFF;">有效资源规划和管理</span>的重要工具</div>
          <div v-else :style="titleStyle" class="title-1 mg-b-30">{{ titleRow2 }}<span style="color: #016BFF;">{{ blueText }}</span></div>
          <div :class="[{'flex-box': tipsFlex}, 'ilne-box']">
            <div class="line-item" v-for="(item, index) in titleTipsList" :key="index">
              <img :src="CancelImg" alt="">
              <span class="line-text">{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import Cancel from '@/assets/home/banner_check.svg'
export default {
  props: {
    topBannerImg: {
      type: String,
      default: ''
    },
    title2: {
      type: String,
      default: ''
    },
    titleRow1: {
      type: String,
      default: ''
    },
    titleRow2: {
      type: String,
      default: ''
    },
    blueText: {
      type: String,
      default: ''
    },
    titleTipsList: {
      type: Array,
      default: () => {
        return []
      }
    },
    tipsFlex: {
      type: Boolean,
      default: false
    },
    special: {
      type: Boolean,
      default: false
    },
    contentStype: {
      type: Object,
      default: () => {
        return {}
      }
    },
    titleStyle: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
   data() {
      return {
        CancelImg: Cancel,
      }
   },
   created(){
   },
   computed:{
   },
   methods:{
   },
}
</script>
<style lang="less" scoped>
.top {
  width: 100%;
}
.center-box {
  display: flex;
  justify-content: center;
}
.max-width-1920 {
  max-width: 1920px;
  width: 100%;
}
.top-box {
  width: 100%;
  min-width: 1200px;
  height: 600px;
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center;
  display: flex;
  justify-content: center;
}
.banner-img {
  width: 100%;
  min-width: 1200px;
  height: auto;
}
.content-positioning {
  width: 1200px;
  text-align: left;
  font-size: 14px;
  color: #3E4755;
  line-height: 19px;
  padding-top: 106px;
}
.title-2 {
  font-size: 30px;
  color: #020814;
  line-height: 42px;
  margin-bottom: 14px;
}
.title-1 {
  font-weight: bold;
  font-size: 42px;
  color: #222222;
  line-height: 57px;
  letter-spacing: 1px;
}
.mg-b-30 {
  margin-bottom: 30px;
}
.line-item {
  margin-bottom: 17px;
}
.line-text {
  padding-left: 8px;
}
.flex-box {
  display: flex;
  flex-wrap: wrap;
  width: 485px;
}
.flex-box .line-item {
  margin-right: 30px;
}
.title-font{
  font-size: 32px;
}
</style>
